import { CreateLegalRepresentativeDTO, FindAllLegalRepresentativesFiltersDTO, FindAllLegalRepresentativesResponseDTO, LegalRepresentativesResponseDTO, UpdateLegalRepresentativeDTO } from "./dto"
import { LegalRepresentativeServiceImpl } from "./serviceImpl"


export interface LegalRepresentativeService {
    findAllLegalRepresentatives(filters: FindAllLegalRepresentativesFiltersDTO): Promise<FindAllLegalRepresentativesResponseDTO>
    getLegalRepresentativeById(id: string): Promise<LegalRepresentativesResponseDTO>
    updateLegalRepresentative(id: string, data: UpdateLegalRepresentativeDTO): Promise<void>
    createLegalRepresentative(data: CreateLegalRepresentativeDTO): Promise<number>
    removeLegalRepresentative(id: string): Promise<void>
    deleteLegalRepresentative(id: string): Promise<void>
}


export function NewLegalRepresentativeService(): LegalRepresentativeService {
    return new LegalRepresentativeServiceImpl();
}